import { WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';

import { SAL1011_R01Dto, SAL1011_R01HeaderDto, SAL1011_R01DetailDto } from './Dto_SAL1011_R01';
import { SAL1011_R01Filter } from "./Store_SAL1011_R01";

const baseUrl = `${config.apiUrl}/SAL1011_R01`;

const getParams = (params: Partial<SAL1011_R01Filter>, listLength?: number) => {
	return {
		compCd: params?.compCd || '',
		startDate: params?.dateRange?.from ? formatDate(params.dateRange.from) : '',
		endDate: params?.dateRange?.to ? formatDate(params.dateRange.to) : '',
		customCd: params?.customCd || '',
		orderStatus: params?.orderStatus || '',
		listLength: listLength || 0
	}
}

/**
 * 판매주문 헤더 목록 조회
 * @param condition 검색 조건 (사업장, 거래처, 시작일, 종료일)
 * @returns 판매주문 헤더 목록
 */
export const getSAL1011_R01HeaderList = async (
	option: string,
	params: Partial<SAL1011_R01Filter>,
	listLength: number = 0
) => {
	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<SAL1011_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
};

export const getSAL1011_R01AllCount = async (params: Partial<SAL1011_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
};

export const getSAL1011_R01One = async (salesOrderNo: string) => {
	const url = `${baseUrl}/one/${salesOrderNo}`;
	return await getData<ResponseDto<SAL1011_R01HeaderDto>>(url);
};

/**
 * 판매주문 상세 목록 조회
 * @param salesOrderNo 판매주문번호
 * @returns 판매주문 상세 목록
 */
export const getSAL1011_R01DetailList = async (salesOrderNo: string) => {
  const url = `${baseUrl}/detail/${salesOrderNo}`;

  return await getData<ResponseDto<SAL1011_R01DetailDto[]>>(url);
};

export const getSAL1011_R01ProductResult = async (salesOrderNo: string) => {
  const url = `${baseUrl}/productResult/${salesOrderNo}`;

  return await getData<ResponseDto<WmsTransportHeaderDto>>(url);
};

/**
 * 판매주문 등록 (헤더 + 상세 동시 등록)
 * @param data 판매주문 전체 데이터
 * @returns 등록된 판매주문 데이터
 */
export const postSAL1011_R01 = async (data: SAL1011_R01Dto) => {
  const url = `${baseUrl}`;

  return await postData<SAL1011_R01Dto, ResponseDto<SAL1011_R01Dto[]>>(url, data);
};

/**
 * 판매주문 수정 (헤더 + 상세 전체 수정)
 * @param data 수정할 판매주문 전체 데이터
 * @returns 수정된 판매주문 데이터
 */
export const patchSAL1011_R01 = async (data: SAL1011_R01Dto) => {
  const url = `${baseUrl}`;

  return await patchData<SAL1011_R01Dto, ResponseDto<SAL1011_R01Dto[]>>(url, data);
};

/**
 * 판매주문 삭제
 * @param salesOrderNo 판매주문번호
 * @returns 삭제 결과
 */
export const deleteSAL1011_R01 = async (salesOrderNo: string) => {
  const url = `${baseUrl}`;

  return await deleteData<ResponseDto<void>>(url, {
    params: {
      salesOrderNo
    }
  });
};

/**
 * @param option 검색 옵션 ('search' 또는 빈 문자열)
 * @param salesOrderNo 선택된 매출주문번호
 * @param listLength 목록 길이
 * @returns 엑셀 데이터
 */
export const downloadExcel_SAL1011_R01 = async (option: string, salesOrderNo: string, listLength: number = 0) => {
  const url = `${baseUrl}/excel/${option}`;
  
  return await getData<ResponseDto<string>>(url, {
    params: {
      salesOrderNo
    }
  });
};

/** 판매주문서 PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_SAL1011_R01 = async (salesOrderNo: string): Promise<Blob> => {
  const url = `${baseUrl}/print`;
  const response = await getData<Blob>(url, {
    params: { salesOrderNo },
    responseType: "blob",
  });
  return new Blob([response.data], { type: "application/pdf" });
};
